import { useState, useEffect, useCallback } from 'react';

const slides = [
  {
    title: '某顶流男星绯闻女友身份曝光',
    excerpt: '持续追踪三个月，终于拍到实锤画面。女方身份信息已确认，背后还有更多内幕待揭开……',
    tag: '独家爆料',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20red%20abstract%20editorial%20background%20with%20soft%20geometric%20overlays%2C%20dramatic%20spotlight%20effect%2C%20modern%20magazine%20cover%20style%2C%20luxurious%20dark%20aesthetic%2C%20rich%20burgundy%20and%20amber%20accents%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20entertainment%20news%20visual&width=1200&height=600&seq=carousel-01&orientation=landscape',
    heat: '1,286万',
  },
  {
    title: '知名女博主人设崩塌完整时间线',
    excerpt: '从带货翻车到感情造假，百万粉丝博主人设一夜崩塌。吃瓜群众：原来都是演的？',
    tag: '深度追踪',
    img: 'https://readdy.ai/api/search-image?query=Deep%20warm%20amber%20gradient%20abstract%20composition%2C%20layered%20translucent%20geometric%20patterns%2C%20cinematic%20atmosphere%2C%20soft%20light%20bleed%20from%20center%2C%20modern%20editorial%20design%2C%20rich%20gold%20and%20dark%20crimson%20tones%2C%20no%20text%2C%20no%20people%2C%20dramatic%20yet%20elegant&width=1200&height=600&seq=carousel-02&orientation=landscape',
    heat: '2,058万',
  },
  {
    title: '网曝门最新猛料：圈内大佬牵扯其中',
    excerpt: '匿名投稿人提供大量聊天记录和转账截图，多位圈内知名人士被点名。事件仍在持续发酵……',
    tag: '网曝门',
    img: 'https://readdy.ai/api/search-image?query=Dark%20coral%20and%20deep%20purplish%20red%20abstract%20backdrop%2C%20dramatic%20light%20rays%20breaking%20through%2C%20mysterious%20atmosphere%2C%20modern%20news%20magazine%20aesthetic%2C%20bold%20contrast%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20visually%20striking&width=1200&height=600&seq=carousel-03&orientation=landscape',
    heat: '3,421万',
  },
  {
    title: '吃瓜年度盘点：那些塌房的千万网红',
    excerpt: '复盘过去一年全网最轰动的十起网红塌房事件，看51吃瓜黑料带你回顾这些经典名场面。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20gradient%20abstract%20composition%20with%20coral%20and%20gold%20highlights%2C%20soft%20dreamy%20bokeh%20effect%2C%20modern%20editorial%20year%20in%20review%20visual%2C%20sophisticated%20luxurious%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20rich%20warm%20tones%20with%20dramatic%20lighting&width=1200&height=600&seq=carousel-04&orientation=landscape',
    heat: '892万',
  },
];

export default function Carousel() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            头条焦点
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Headlines
          </span>
        </div>

        <div className="relative overflow-hidden rounded-2xl">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {slides.map((slide, i) => (
              <div key={i} className="w-full flex-shrink-0">
                <div className="relative aspect-[21/9] md:aspect-[21/8] rounded-2xl overflow-hidden">
                  <img
                    src={slide.img}
                    alt={slide.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
                    <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold mb-3 whitespace-nowrap">
                      {slide.tag}
                    </span>
                    <h3 className="text-xl md:text-3xl font-heading text-white mb-2 line-clamp-2">
                      {slide.title}
                    </h3>
                    <p className="text-sm md:text-base text-white/70 max-w-2xl line-clamp-2">
                      {slide.excerpt}
                    </p>
                    <div className="flex items-center gap-1 mt-3 text-white/50 text-xs">
                      <i className="ri-fire-line text-accent-400"></i>
                      <span className="whitespace-nowrap">热度 {slide.heat}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${
                  i === current
                    ? 'w-6 h-2 bg-primary-500'
                    : 'w-2 h-2 bg-white/40 hover:bg-white/60'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}